import { Box, Drawer, SxProps } from '@mui/material';
import React from 'react';
import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import CloseIcon from '@/assets/CloseIcon.svg';
import LencoButton from '@/atomic-components/LencoButton';

type TWhatsCoveredInVasDrawerProps = {
	title?: React.ReactElement | string;
	htmlContent?: string;
	isVisible: boolean;
	onClose: () => void;
	Icon?: any;
	children?: React.ReactElement;
	ButtonProps?: {
		sx?: SxProps;
	};
	drawerContainerSx?: SxProps;
};

function WhatsCoveredInVasDrawer(props: TWhatsCoveredInVasDrawerProps) {
	return (
		<Drawer
			anchor={'right'}
			open={props.isVisible}
			variant='temporary'
			onClose={props.onClose}
			// sx={{ zIndex: 99999 }}
		>
			<FlexBox
				direction='column'
				sx={{
					padding: '54px 40px',
					width: '413px',
				}}
			>
				<FlexBox
					direction='column'
					alignItems='start'
					sx={{
						justifyContent: 'space-between',
					}}
				>
					<FlexBox fullWidth justifyContent='space-between'>
						{props.title}
						<Box onClick={props.onClose}>
							<CloseIcon />
						</Box>
					</FlexBox>
					{props.htmlContent ? (
						<Box
							sx={{
								div: {
									...getStyle('P_Medium'),
									color: getColor('Gray 0'),
									mt: '16px',
								},
								p: {
									...getStyle('P_Medium'),
									color: getColor('Gray 0'),
									mt: '16px',
								},
								mb: '24px',
								ul: {
									ml: '24px',
								},
								li: {
									...getStyle('Small_Regular'),
									mt: '8px',
									color: getColor('Gray -2'),
								},
							}}
							dangerouslySetInnerHTML={{ __html: props.htmlContent }}
						/>
					) : (
						props.children
					)}
				</FlexBox>
			</FlexBox>
		</Drawer>
	);
}

export default React.memo(WhatsCoveredInVasDrawer);
